/**
 * Copyright 2021 Opstrace, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CockroachMetricsForm } from "./Form";
import { CockroachMetricsShow } from "./Show";
import CockroachMetricsStatus from "./Status";
import CockroachMetricsLogo from "./Logo.png";

import { IntegrationDef } from "client/integrations/types";

export const cockroachMetricsIntegration: IntegrationDef = {
  kind: "cockroach-metrics",
  category: "infrastructure",
  label: "CockroachDB Metrics",
  desc:
    "Run a grafana-agent metrics exporter to send metrics from your CockroachDB cluster to this tenant. We'll install bundled dashboards for monitoring CockroachDB with this integration.",
  Form: CockroachMetricsForm,
  Show: CockroachMetricsShow,
  Status: CockroachMetricsStatus,
  enabled: true,
  Logo: CockroachMetricsLogo
};
